<template>
  <div class="box" v-if="highEndTipsInfo.text">
    <div class="text-box">
      <p class="text">{{ highEndTipsInfo.text }}</p>
    </div>
    <!-- <notification :type="typeA"
     :message="highEndTipsInfo" :showClose="false" :showButton="false" :showImage="false"
      :noticeStyle='{
        borderColor:"F7E6D3_707070",
        backgroundColor: "FDF8F0_707070",
        borderRadius: "12px",
      }' /> -->
  </div>
</template>

<script>
export default {
  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 数据
    mergeData: Object, // 聚合数据
  },

  components: {

  },

  computed: {
    highEndTipsInfo() {
      const highEndTipsInfo = this.mergeData?.highEndTipsInfo || '';
      return { text: highEndTipsInfo };
    },
  },
};
</script>

<style scoped>
.box {
  /* margin: 24px; */
}

.text-box {
  border: 1px solid #F7E6D3;
  background-color: #FDF8F0;
  border-radius: 12px;
  padding: 16px;
}

.text {
  font-size: 24px;
}
</style>
